var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 128,
    viewBox: "0 0 671 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.4 40.4992H188.8V21.1992H179V69.6992H188.8V50.2992H216.7L217.7 51.2992V69.6992H227.5V47.9992L220 40.4992H210.5L229.8 21.1992H216.7L197.4 40.4992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.902 57.8008L245.902 56.8008H273.702V69.7008H283.502V28.7008L276.102 21.3008H268.302L235.102 54.5008V69.7008H244.902V57.8008ZM272.802 31.0008L273.802 31.9008V46.9008H255.702L271.602 30.9008H272.802V31.0008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.4 21.1992L292 28.5992V37.3992H301.8V31.9992L302.8 30.9992H329.7L330.7 31.9992V39.5992L329.7 40.4992H315.9V50.2992H329.7L330.7 51.2992V58.8992L329.7 59.8992H302.8L301.8 58.8992V53.3992H292V62.1992L299.4 69.6992H333L340.5 62.1992V47.9992L337.9 45.3992L340.5 42.8992V28.5992L333 21.1992H299.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.501 21.1992L348.301 54.3992V69.5992H358.101V57.6992L359.101 56.6992H386.901V69.5992H396.701V28.5992L389.301 21.1992H381.501ZM386.001 30.9992L387.001 31.8992V46.8992H368.901L384.801 30.8992H386.001V30.9992Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M444.799 40.4992H415.999V21.1992H406.199V69.6992H415.999V50.2992H444.799V69.6992H454.599V21.1992H444.799V40.4992Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M474.8 40.4992V21.1992H465V69.5992H506L513.4 62.1992V47.8992L506 40.4992H474.8ZM474.8 59.8992V50.3992H502.7L503.7 51.3992V58.9992L502.7 59.9992H474.8V59.8992Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.599 78.5L179.199 85.9V119.5L186.599 126.9H220.199L227.599 119.5V85.9L220.199 78.5H186.599ZM189.899 117.2L188.899 116.2V89.2L189.899 88.2H216.899L217.799 89.2V116.2L216.899 117.2H189.899Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236.898 78.5V126.9H246.698V107.6H277.898L285.298 100.2V85.9L277.898 78.5H236.898ZM246.698 88.3H274.598L275.498 89.3V96.9L274.598 97.9H246.698V88.3Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5 126.9H303.3V88.3H335.5V78.5H293.5V126.9Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.398 85.9V119.5L348.798 126.9H389.798V117.2H352.198L351.198 116.2V89.2L352.198 88.3H389.798V78.5H348.798L341.398 85.9Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M437.702 90.4L411.002 117.2H409.802L408.902 116.2V78.5H399.102V119.5L406.502 126.9H414.302L437.702 103.5V126.9H447.502V78.5H437.702V90.4Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M494.302 97.8H465.402V78.5H455.602V126.9H465.402V107.6H494.302V126.9H504.102V78.5H494.302V97.8Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512.199 88.3H531.599V126.9H541.299V88.3H560.699V78.5H512.199V88.3Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 85.9V100.2L569.1 102.7L566.5 105.3V119.5L574 126.9H615V117.2H577.3L576.3 116.2V108.6L577.3 107.6H615V97.8H577.3L576.3 96.9V89.2L577.3 88.3H615V78.5H574L566.5 85.9Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M670.602 85.9L663.102 78.5H629.502L622.102 85.9V94.7H631.902V89.2L632.902 88.3H659.802L660.802 89.2V96.9L659.802 97.8H645.902V107.6H659.802L660.802 108.6V116.2L659.802 117.2H632.902L631.902 116.2V110.7H622.102V119.5L629.502 126.9H663.102L670.602 119.5V105.3L668.002 102.7L670.602 100.2V85.9Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.201 92.3008H31.3008V127.601H103.201V92.3008Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0984 63.1992H41.3984V88.3992H93.0984V63.1992Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6008 39.5996H52.8008V59.1996H81.6008V39.5996Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3016 0L61.6016 35.6H72.8016L68.2016 0H66.3016Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.301 71.4998C123.901 64.9998 134.001 66.9998 134.001 66.9998L131.701 42.8998L122.501 42.6999C111.201 42.2999 102.101 46.7998 105.001 62.4998C106.101 68.3998 110.201 74.1999 113.801 80.6999C115.701 84.1999 115.201 91.0999 107.701 92.1999V92.3998V127.7C108.601 127.7 109.701 127.7 110.901 127.7C125.001 127.3 134.501 116.8 134.501 104.1C134.401 84.5999 122.301 81.5998 123.301 71.4998Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 92.3003V92.1003C19.2 90.9003 18.7 84.0003 20.7 80.6003C24.3 74.2003 28.4 68.4002 29.5 62.4002C32.4 46.7002 23.3 42.2002 12 42.6002L2.8 42.8003L0.5 66.9002C0.5 66.9002 10.6 64.8002 11.2 71.4002C12.2 81.5002 0.1 84.5002 0 103.9C0 116.7 9.50001 127.1 23.6 127.5C24.8 127.5 25.8 127.5 26.8 127.5V92.3003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/Казань Оргсинтез.4b59dcb28e8c5825b8082f8096f91b53.svg";
export { ForwardRef as ReactComponent };